export const IMAGES = {
  heroTexture:
    "/assets/img/photo-1580824469841-49c0f1401393.jpg",
  candles:
    "/assets/img/photo-1760367119608-2b0b33786c94.jpg",
  career:
    "/assets/img/photo-1573497019940-1c28c88b4f3e.jpg",
  wellness:
    "/assets/img/photo-1589156280159-27698a70f29e.jpg",
  faith:
    "/assets/img/photo-1607746882042-944635dfe10e.jpg",
  teens:
    "/assets/img/premium_photo-1658526904282-5feb6958fcdc.jpg",
  housing:
    "/assets/img/photo-1472224371017-08207f84aaae.jpg",
};

// kind: "community" | "clinical" (clinical = licensed care / crisis professionals)
// location tags: triad | nc | national | virtual
// cost tags: free | low-cost | insurance | varies
// format tags: in-person | virtual | either
// season tags: teen | young-adult | mother | career | every

export const PATHWAYS = [
  {
    id: "purpose-provision",
    name: "Purpose & Provision",
    short: "Career, education, leadership, work, business, and financial-forward support",
    cta: "Find career support",
    resultsTitle: "Career support near you",
    resultsSub: "Showing free, low-cost, and virtual options for women in the Triad and across North Carolina.",
    big: true,
    resources: [
      {
        name: "Start Here: Career Support",
        description: "Our own résumé refresh checklist, career-planning worksheet, and mentor-interest pathway — made by S.H.E. Warriors for your first step.",
        bestFor: "Career transition, job search, résumé refresh",
        available: "Triad / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad"], cost: ["free"], format: ["in-person"], seasons: ["career", "young-adult", "every"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
        featured: true,
      },
      {
        name: "Career OneStop",
        description: "Free job-search guides, training finders, and interview tools from the U.S. Department of Labor.",
        bestFor: "Job search, training, career planning",
        available: "National / Virtual",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["career", "young-adult", "every"] },
        action: { label: "careeronestop.org", href: "https://www.careeronestop.org" },
        reviewed: "August 2026",
      },
      {
        name: "NCWorks Career Centers",
        description: "North Carolina's free career centers — coaching, workshops, and job connections, with Triad locations.",
        bestFor: "Job placement support, workforce training",
        available: "North Carolina / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "triad"], cost: ["free"], format: ["in-person"], seasons: ["career", "every"] },
        action: { label: "ncworks.gov", href: "https://www.ncworks.gov" },
        reviewed: "August 2026",
      },
      {
        name: "Black Career Women's Network",
        description: "Career and leadership development, coaching, and community built specifically for Black women.",
        bestFor: "Career transition, leadership, coaching, professional growth",
        available: "National / Virtual",
        cost: "Varies by program",
        kind: "community",
        tags: { location: ["national", "virtual"], cost: ["varies"], format: ["virtual"], seasons: ["career"] },
        action: { label: "bcwnetwork.com", href: "https://www.bcwnetwork.com" },
        reviewed: "August 2026",
      },
      {
        name: "Dress for Success",
        description: "Professional attire, coaching, and a network of women championing your next step.",
        bestFor: "Interview clothing, confidence, job readiness",
        available: "National / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "triad"], cost: ["free"], format: ["in-person"], seasons: ["career", "young-adult", "every"] },
        action: { label: "dressforsuccess.org", href: "https://dressforsuccess.org" },
        reviewed: "August 2026",
      },
      {
        name: "SBA Women's Business Centers",
        description: "Entrepreneurship training, funding guidance, and free business counseling for women founders.",
        bestFor: "Starting or growing a business",
        available: "National / Virtual & in person",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["either"], seasons: ["career", "every"] },
        action: { label: "sba.gov", href: "https://www.sba.gov" },
        reviewed: "August 2026",
      },
    ],
  },
  {
    id: "mind-wellness",
    name: "Mind & Wellness",
    short: "Mental well-being, rest, therapy referrals, grief, burnout, and healing",
    cta: "Explore wellness support",
    resultsTitle: "Wellness support near you",
    resultsSub: "Education, trusted referrals, and community care — clearly labeled so you know what kind of help each one is.",
    big: true,
    resources: [
      {
        name: "Start Here: Mind & Wellness",
        description: "Our gentle self-care checklist and one-week exhale plan — small, doable steps for heavy seasons, made by S.H.E. Warriors.",
        bestFor: "Overwhelm, burnout, where-do-I-start moments",
        available: "Virtual / this site",
        cost: "Free",
        kind: "community",
        tags: { location: ["virtual", "triad"], cost: ["free"], format: ["either"], seasons: ["every", "mother", "career", "young-adult"] },
        action: { label: "Begin with Quiet Hour", href: "/gatherings", internal: true },
        reviewed: "August 2026",
        featured: true,
      },
      {
        name: "Therapy for Black Girls",
        description: "A therapist-finder and podcast dedicated to the mental wellness of Black women and girls.",
        bestFor: "Finding a licensed therapist who understands you",
        available: "National / Virtual",
        cost: "Insurance / varies",
        kind: "clinical",
        tags: { location: ["national", "virtual"], cost: ["insurance", "varies"], format: ["virtual"], seasons: ["every", "young-adult", "mother", "career"] },
        action: { label: "therapyforblackgirls.com", href: "https://www.therapyforblackgirls.com" },
        reviewed: "August 2026",
      },
      {
        name: "The Loveland Foundation",
        description: "Therapy fund and mental-wellness resources helping Black women and girls afford care.",
        bestFor: "Affording therapy, healing resources",
        available: "National / Virtual",
        cost: "Low-cost / fund-based",
        kind: "clinical",
        tags: { location: ["national", "virtual"], cost: ["low-cost"], format: ["virtual"], seasons: ["every", "young-adult"] },
        action: { label: "thelovelandfoundation.org", href: "https://thelovelandfoundation.org" },
        reviewed: "August 2026",
      },
      {
        name: "NAMI Helpline",
        description: "The National Alliance on Mental Illness answers questions and points you to local care and support groups.",
        bestFor: "Understanding options, support groups, education",
        available: "National / Virtual",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["every"] },
        action: { label: "1-800-950-6264", href: "tel:18009506264" },
        reviewed: "August 2026",
      },
      {
        name: "Postpartum Support International",
        description: "Free support groups and a helpline for mothers navigating pregnancy and postpartum seasons.",
        bestFor: "New mothers, postpartum anxiety and depression",
        available: "National / Virtual",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["mother"] },
        action: { label: "postpartum.net", href: "https://www.postpartum.net" },
        reviewed: "August 2026",
      },
      {
        name: "Quiet Hour — Guided Reflection",
        description: "Our own weekly rhythm of scripture, silence, and journaling — a place to exhale before the day begins.",
        bestFor: "Burnout, overwhelm, a gentle weekly reset",
        available: "Triad & online",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad", "virtual"], cost: ["free"], format: ["either"], seasons: ["every", "mother", "career"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
      },
      {
        name: "988 Suicide & Crisis Lifeline",
        description: "Free, 24/7 professional support for anyone in emotional distress or crisis.",
        bestFor: "Urgent mental-health support, any hour",
        available: "National / Call or text",
        cost: "Free",
        kind: "clinical",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["every", "teen", "young-adult", "mother", "career"] },
        action: { label: "Call or text 988", href: "tel:988" },
        reviewed: "August 2026",
      },
    ],
  },
  {
    id: "faith-flourishing",
    name: "Faith & Flourishing",
    short: "Prayer, Scripture, mentoring, worship, and spiritual community",
    cta: "Grow in faith",
    resultsTitle: "Faith & spiritual growth",
    resultsSub: "Circles, studies, prayer, and worship — gentle ways to grow roots and rise.",
    big: true,
    resources: [
      {
        name: "Sacred Sister Circles",
        description: "Intimate weekly study, prayer, and deep soul-care with women who will know your name.",
        bestFor: "Sisterhood, Bible study, being known",
        available: "Triad / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad"], cost: ["free"], format: ["in-person"], seasons: ["every", "young-adult", "mother", "career"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
        featured: true,
      },
      {
        name: "Prayer & Reflection",
        description: "Leave a worry or a prayer in our confidential space — the sisterhood quietly covers you all week.",
        bestFor: "Prayer support, heavy seasons, anonymity",
        available: "Virtual / this site",
        cost: "Free",
        kind: "community",
        tags: { location: ["virtual"], cost: ["free"], format: ["virtual"], seasons: ["every"] },
        action: { label: "Leave a prayer", href: "#prayer-engine", anchor: true },
        reviewed: "August 2026",
      },
      {
        name: "Quiet Hour Bible Study",
        description: "Thirty unhurried minutes of scripture and journaling, Thursday mornings online and in person.",
        bestFor: "Daily devotion, morning rhythm",
        available: "Triad & online",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad", "virtual"], cost: ["free"], format: ["either"], seasons: ["every"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
      },
      {
        name: "YouVersion Bible App",
        description: "Free devotionals, reading plans, and scripture on your phone — a gentle daily companion.",
        bestFor: "Devotionals, reading plans, daily scripture",
        available: "National / Virtual",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["every", "teen"] },
        action: { label: "youversion.com", href: "https://www.youversion.com" },
        reviewed: "August 2026",
      },
      {
        name: "The Exhale Retreat",
        description: "Our weekend retreat — rest, worship, and renewal away from the noise.",
        bestFor: "Deep rest, worship, renewal",
        available: "Triad / In person",
        cost: "Low-cost",
        kind: "community",
        tags: { location: ["triad"], cost: ["low-cost"], format: ["in-person"], seasons: ["every", "mother", "career"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
      },
      {
        name: "Faith Mentorship",
        description: "One-to-one spiritual mentoring with a seasoned sister — or become a mentor yourself.",
        bestFor: "Mentorship, discipleship, life questions",
        available: "Triad / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad"], cost: ["free"], format: ["in-person"], seasons: ["every", "young-adult"] },
        action: { label: "Get Involved", href: "/get-involved", internal: true },
        reviewed: "August 2026",
      },
    ],
  },
  {
    id: "roots-wings",
    name: "Roots & Wings",
    short: "Support for girls, teens, parents, and mentors",
    cta: "Find support for her",
    resultsTitle: "For girls, teens & their parents",
    resultsSub: "Age-aware support — always with parent or guardian involvement for minors.",
    big: false,
    resources: [
      {
        name: "Becoming Her (Ages 12–18)",
        description: "Our mentorship and study group for teen girls — identity, school pressure, and faith, with guardians involved.",
        bestFor: "Teen girls, identity, school pressure",
        available: "Triad / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad"], cost: ["free"], format: ["in-person"], seasons: ["teen"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
        featured: true,
      },
      {
        name: "Little Lights (Ages 5–11)",
        description: "Joyful discipleship and creative resources for young girls, side by side with their parents.",
        bestFor: "Young girls, family discipleship",
        available: "Triad / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad"], cost: ["free"], format: ["in-person"], seasons: ["every", "mother"] },
        action: { label: "See Gatherings", href: "/gatherings", internal: true },
        reviewed: "August 2026",
      },
      {
        name: "Big Brothers Big Sisters",
        description: "One-to-one mentoring that helps girls thrive in school and in life.",
        bestFor: "Youth mentoring, consistent adult presence",
        available: "National / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "nc", "triad"], cost: ["free"], format: ["in-person"], seasons: ["teen"] },
        action: { label: "bbbs.org", href: "https://www.bbbs.org" },
        reviewed: "August 2026",
      },
      {
        name: "Girls Inc.",
        description: "Research-based programs that equip girls to navigate school pressure and lead.",
        bestFor: "Girls' leadership, school support",
        available: "National / In person",
        cost: "Low-cost",
        kind: "community",
        tags: { location: ["national"], cost: ["low-cost"], format: ["in-person"], seasons: ["teen"] },
        action: { label: "girlsinc.org", href: "https://girlsinc.org" },
        reviewed: "August 2026",
      },
      {
        name: "Teen Line",
        description: "Teens helping teens — call 1-800-852-8336 or text TEEN to 839863 (evenings).",
        bestFor: "Teens who need to talk tonight",
        available: "National / Call or text",
        cost: "Free",
        kind: "clinical",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["teen"] },
        action: { label: "1-800-852-8336", href: "tel:18008528336" },
        reviewed: "August 2026",
      },
    ],
  },
  {
    id: "benefits-stability",
    name: "Benefits & Stability",
    short: "Food, health coverage, child care, housing, utilities, and essential-needs guidance",
    cta: "Find practical help",
    resultsTitle: "Benefits & stability",
    resultsSub: "If you need help with food, health coverage, child care, utilities, housing, or other basic needs, you are not failing — you are taking a step toward stability.",
    big: true,
    resources: [
      {
        name: "Emergency Services",
        description: "If you or someone near you is in immediate danger, call 911 now.",
        bestFor: "Immediate physical danger",
        available: "National / 24-7",
        cost: "Free",
        kind: "clinical",
        tags: { location: ["national"], cost: ["free"], format: ["either"], seasons: ["every", "teen", "young-adult", "mother", "career"] },
        action: { label: "Call 911", href: "tel:911" },
        reviewed: "August 2026",
      },
      {
        name: "Start With a Benefits Check",
        description: "Not sure what you qualify for? ePASS and the U.S. Benefit Finder match your household to programs in minutes — see the guide below.",
        bestFor: "“I do not know what I qualify for.”",
        available: "National & NC / Virtual",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["every"] },
        action: { label: "usa.gov/benefit-finder", href: "https://www.usa.gov/benefit-finder" },
        reviewed: "August 2026",
        featured: true,
      },
      {
        name: "Food & Grocery Support",
        description: "NC Food & Nutrition Services (FNS/SNAP), WIC, local food pantries, and NC 211 — start with a simple application.",
        bestFor: "“I need help buying food.”",
        available: "North Carolina / Online & in person",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "triad", "virtual"], cost: ["free"], format: ["either"], seasons: ["every", "mother"] },
        action: { label: "Apply via ePASS", href: "https://epass.nc.gov" },
        reviewed: "August 2026",
      },
      {
        name: "Health Coverage",
        description: "NC Medicaid (including expansion eligibility) and Marketplace coverage through HealthCare.gov.",
        bestFor: "“I need health insurance.”",
        available: "North Carolina / Online & in person",
        cost: "Free to apply",
        kind: "clinical",
        tags: { location: ["nc", "triad", "virtual"], cost: ["free"], format: ["either"], seasons: ["every", "mother", "young-adult"] },
        action: { label: "medicaid.ncdhhs.gov", href: "https://medicaid.ncdhhs.gov" },
        reviewed: "August 2026",
      },
      {
        name: "Housing, Utilities & Transportation",
        description: "Local rental and energy assistance, housing navigators, and essential-needs referrals through NC 211.",
        bestFor: "“I am struggling with rent or bills.”",
        available: "Triad & NC / Call or online",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "triad"], cost: ["free"], format: ["either"], seasons: ["every", "mother"] },
        action: { label: "Talk to NC 211", href: "tel:211" },
        reviewed: "August 2026",
      },
      {
        name: "Support for Children & Families",
        description: "Child care assistance, WIC, Medicaid for children, Work First/TANF, and school resources.",
        bestFor: "“I need support for my children.”",
        available: "North Carolina / Online & in person",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "triad"], cost: ["free"], format: ["either"], seasons: ["mother"] },
        action: { label: "Explore via NC 211", href: "https://nc211.org" },
        reviewed: "August 2026",
      },
      {
        name: "Income, Work & Career Support",
        description: "Unemployment through NC DES, workforce services, job training, and benefits screening.",
        bestFor: "“I lost income or need work.”",
        available: "North Carolina / Online & in person",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "triad", "virtual"], cost: ["free"], format: ["either"], seasons: ["career", "every"] },
        action: { label: "des.nc.gov", href: "https://www.des.nc.gov" },
        reviewed: "August 2026",
      },
      {
        name: "988 Suicide & Crisis Lifeline",
        description: "Free, 24/7 professional support for mental-health or suicide crisis.",
        bestFor: "Emotional crisis, any hour",
        available: "National / Call or text",
        cost: "Free",
        kind: "clinical",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["every", "teen"] },
        action: { label: "Call or text 988", href: "tel:988" },
        reviewed: "August 2026",
      },
      {
        name: "National Domestic Violence Hotline",
        description: "24/7 confidential support, safety planning, and safe-house referrals.",
        bestFor: "Family safety, leaving safely",
        available: "National / Call, text, chat",
        cost: "Free",
        kind: "clinical",
        tags: { location: ["national", "virtual"], cost: ["free"], format: ["virtual"], seasons: ["every", "mother"] },
        action: { label: "1-800-799-7233", href: "tel:18007997233" },
        reviewed: "August 2026",
      },
      {
        name: "Family Services of Forsyth County",
        description: "Local domestic-violence shelter, counseling, and family support right here in Winston-Salem.",
        bestFor: "Local shelter, family safety, counseling",
        available: "Triad / In person",
        cost: "Free",
        kind: "clinical",
        tags: { location: ["triad"], cost: ["free"], format: ["in-person"], seasons: ["every", "mother"] },
        action: { label: "familyservicesforsyth.org", href: "https://www.familyservicesforsyth.org" },
        reviewed: "August 2026",
      },
      {
        name: "211 — Housing & Essentials",
        description: "Emergency shelter beds, rental assistance, food, transportation, and utility help near you.",
        bestFor: "Housing, food, transportation, bills",
        available: "National / Call",
        cost: "Free",
        kind: "community",
        tags: { location: ["national", "nc", "triad"], cost: ["free"], format: ["either"], seasons: ["every", "mother"] },
        action: { label: "Dial 211", href: "tel:211" },
        reviewed: "August 2026",
      },
      {
        name: "Second Harvest Food Bank of NWNC",
        description: "The Triad's own food bank — groceries and meal programs across Northwest North Carolina.",
        bestFor: "Food for your table this week",
        available: "Triad / In person",
        cost: "Free",
        kind: "community",
        tags: { location: ["triad", "nc"], cost: ["free"], format: ["in-person"], seasons: ["every", "mother"] },
        action: { label: "secondharvestnwnc.org", href: "https://www.secondharvestnwnc.org" },
        reviewed: "August 2026",
      },
      {
        name: "Legal Aid of North Carolina",
        description: "Free legal help with housing, family, safety orders, and benefits for qualifying women.",
        bestFor: "Legal and family support, protective orders",
        available: "North Carolina / In person & virtual",
        cost: "Free",
        kind: "community",
        tags: { location: ["nc", "triad"], cost: ["free"], format: ["either"], seasons: ["every", "mother"] },
        action: { label: "legalaidnc.org", href: "https://legalaidnc.org" },
        reviewed: "August 2026",
      },
    ],
  },
];

export const PILLARS = [
  {
    number: "01",
    name: "Connect",
    text: "Sisterhood and gatherings — circles where women are known by name and met without judgment.",
  },
  {
    number: "02",
    name: "Equip",
    text: "Career tools and mentorship — practical resources that turn worry into a workable next step.",
  },
  {
    number: "03",
    name: "Restore",
    text: "Wellness education and trusted referrals — because healing begins with honest, safe support.",
  },
  {
    number: "04",
    name: "Flourish",
    text: "Faith, worship, and purpose — our hope is not survival but abundance, shared sister to sister.",
  },
];
